export default __webpack_public_path__ + "static/M18-879d42550e62ea7201e87a75851bf446.png";